import React, { PureComponent } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import {
  defaultDateFilters,
  isDesktopDevice,
  updateDateRange
} from '../../../services/services';
import { historyService } from '../../../services/history';
import { T } from '../../../../../common/locale/translate';

import Adults from '../../../common/components/adults';
import Children from '../../../common/components/children';
import DatePicker from '../../../common/components/datepicker';
import Destination from '../../../common/components/destination';
import FlightAirport from '../../../common/components/flight-airport';
import HotelName from '../../../common/components/hotel_name';
import TripLength from '../../../common/components/trip-length';
import { scrollIt } from '../../../services/animate';

export default class BlogOffersSearch extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      startDate: props.params.departure_date || defaultDateFilters().from,
      endDate: props.params.return_date || defaultDateFilters().to,
      duration:
        props.params && props.params.duration_min
          ? {
              default: {
                min: parseInt(props.params.duration_min),
                max: parseInt(props.params.duration_max)
              }
            }
          : { default: {} },
      default_activity: {
        departure_airports: true,
        duration: true,
        flight_type: true,
        operators: true,
        hotel_name: true
      },
      activity: {
        departure_airports: true,
        duration: true,
        flight_type: true,
        operators: true,
        hotel_name: true
      },
      params: {
        ...props.params
      }
    };
    this.state.durationMin = this.state.params
      ? this.state.params.duration_min
      : 7;
    this.state.returnDateRangeStart = moment
      .unix(this.state.startDate)
      .add(this.state.durationMin, 'days');

    this.wrapperRef = null;

    this.setWrapperRef = element => {
      this.wrapperRef = element;
    };
  }

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  }

  render() {
    return (
      <StyledSection className="filters" ref={this.setWrapperRef}>
        <div className="search">
          <div className="mobile-action-wrapper">
            <button onClick={this.handleMobileToggle} className="search-button">
              {T('filter_results')}{' '}
              <i className="fa fa-search" aria-hidden="true" />{' '}
            </button>
          </div>
          <div className="search-form-outside-wrapper">
            <div className="mobile-header-wrapper">
              <h3 className="mobile-header">
                {' '}
                {T('filter_results')}
                <i
                  className="fa fa-times mobile-toggle-switch"
                  aria-hidden="true"
                  onClick={this.handleMobileToggle}
                />{' '}
              </h3>
            </div>
            <div className="search-form-inside-wrapper">
              <section className="panel basic-filters open">
                <h5 className="header">{T('search_for_trip')}</h5>
                <article className="content">
                  <div className="inner-wrapper">
                    <FlightAirport
                      title={T('departure_from')}
                      ref="departure_airports"
                      filter_active={this.state.activity.departure_airports}
                      departure_airports={this.state.params.departure_airports}
                    />

                    <Destination
                      title={T('trip_direction')}
                      ref="regions"
                      regions={this.state.params.regions}
                    />

                    <HotelName
                      title={T('hotel_name_filter')}
                      ref="hotel_name"
                      hotel_name={this.state.params.hotel_name}
                      filter_active={this.state.activity.hotel_name}
                    />

                    <DatePicker
                      title={T('travel_departure')}
                      ref="departure_date"
                      className="date-from"
                      onChange={this.updateDates.bind(this, 'startDate')}
                      date={this.state.startDate}
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      name="departure_date"
                      selectsStart
                      withPortal={!isDesktopDevice()}
                    />

                    <DatePicker
                      title={T('travel_arrival')}
                      ref="return_date"
                      className="date-to"
                      onChange={this.updateDates.bind(this, 'endDate')}
                      date={this.state.endDate}
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      name="return_date"
                      selectsEnd
                      withPortal={!isDesktopDevice()}
                      minDate={this.state.returnDateRangeStart}
                    />

                    <TripLength
                      title={T('travel_time_period')}
                      ref="duration"
                      filter_active={this.state.activity.duration}
                      duration_min={this.state.params.duration_min}
                      duration_max={this.state.params.duration_max}
                      duration={this.state.duration}
                      on_change_duration={this.updateDuration.bind(this)}
                    />

                    <Adults
                      title={T('adults_count_filter')}
                      ref="adults_number"
                      adults_number={this.state.params.adults_number}
                    />

                    <Children
                      title={T('children_count_filter')}
                      ref="children_ages"
                      children_ages={this.state.params.children_ages}
                    />
                  </div>
                  <div className="action-wrapper">
                    <button
                      onClick={this.handleSearch}
                      className="search-button"
                    >
                      <i className="fa fa-search" /> {T('look_for')}
                    </button>
                  </div>
                </article>
              </section>
            </div>
          </div>
        </div>
      </StyledSection>
    );
  }

  updateDates = (name, date) => {
    this.setState(
      updateDateRange(name, date, {
        startDate: this.state.startDate,
        endDate: this.state.endDate
      }),
      () =>
        this.setState({
          returnDateRangeStart: moment
            .unix(this.state.startDate)
            .add(this.state.durationMin, 'days')
        })
    );
  };

  updateDuration = duration => {
    this.setState({
      durationMin: duration.min,
      returnDateRangeStart: moment
        .unix(this.state.startDate)
        .add(duration.min, 'days')
    });
  };

  handleMobileToggle = () => {
    if (document) {
      document.body.classList.toggle('modal-visible');
      this.wrapperRef
        .getElementsByClassName('search-form-outside-wrapper')[0]
        .classList.toggle('active');
    }
  };

  handleSearch = () => {
    scrollIt(0, 800, 'easeOutCubic');
    let temp = {},
      key,
      value;
    if (!isDesktopDevice()) {
      this.handleMobileToggle();
    }
    Object.keys(this.refs).map(v => {
      key = v;
      value = this.refs[v].returnSearchedValue();

      if (value && this.state.activity[key] !== false) {
        switch (key) {
          case 'duration': {
            temp['duration_min'] = value.min;
            temp['duration_max'] = value.max;
            break;
          }
          case 'flight_type': {
            temp['offer_type'] = value;
            break;
          }
          default: {
            temp[key] = value;
          }
        }
      }
    });

    if (!temp['offer_type']) {
      temp['offer_type'] = this.state.params.offer_type
        ? this.state.params.offer_type
        : 'A';
    }

    window.location.href = `/offers?${historyService.parseObject2Params(temp)}`;
  };
}

const StyledSection = styled.section`
  margin-top: 20px;
`;



// WEBPACK FOOTER //
// ./app/javascript/pages/blog/components/blog_offers_search.jsx